import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCampaignmonitorComponent } from './simple-icons-campaignmonitor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCampaignmonitorComponent ],
    exports:      [ SimpleIconsCampaignmonitorComponent ],
    bootstrap:    []
})
export class SimpleIconsCampaignmonitorModule {}
